var _circle, _path, _path2, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankDetailsDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#2EBB49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 15.25H19.25C19.0179 15.25 18.9018 15.25 18.8037 15.2541C16.3345 15.3562 14.3562 17.3345 14.2541 19.8037C14.25 19.9018 14.25 20.0179 14.25 20.25H33.75C33.75 20.0179 33.75 19.9018 33.7459 19.8037C33.6438 17.3345 31.6655 15.3562 29.1963 15.2541C29.0982 15.25 28.9821 15.25 28.75 15.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.75 21.75H14.25V24.2C14.25 27.7622 14.25 29.5434 15.1572 30.792C15.4501 31.1952 15.8048 31.5499 16.208 31.8428C17.4566 32.75 19.2378 32.75 22.8 32.75H25.2C28.7622 32.75 30.5434 32.75 31.792 31.8428C32.1952 31.5499 32.5499 31.1952 32.8428 30.792C33.75 29.5434 33.75 27.7622 33.75 24.2V21.75ZM30.75 24C30.75 24.4142 30.4142 24.75 30 24.75C29.5858 24.75 29.25 24.4142 29.25 24C29.25 23.5858 29.5858 23.25 30 23.25C30.4142 23.25 30.75 23.5858 30.75 24ZM25.5 23.25C25.0858 23.25 24.75 23.5858 24.75 24C24.75 24.4142 25.0858 24.75 25.5 24.75H27.5C27.9142 24.75 28.25 24.4142 28.25 24C28.25 23.5858 27.9142 23.25 27.5 23.25H25.5Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 8,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9989 33.3333C36.3189 33.3333 33.3323 36.3199 33.3323 39.9999C33.3323 43.6799 36.3189 46.6666 39.9989 46.6666C43.6789 46.6666 46.6656 43.6799 46.6656 39.9999C46.6656 36.3199 43.6789 33.3333 39.9989 33.3333ZM38.6656 43.3333L35.3323 39.9999L36.2723 39.0599L38.6656 41.4466L43.7256 36.3866L44.6656 37.3333L38.6656 43.3333Z",
    fill: "#2EBB49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDetailsDone);
export default __webpack_public_path__ + "static/media/bank_details_done.92ecd68567ec4e75cb3e0e1321deb293.svg";
export { ForwardRef as ReactComponent };